export const chartToolbarClasses = {
  viewport: 'max-w-full overflow-x-auto border-b border-white/10 bg-black/10',
  row: 'flex w-full min-w-max items-center gap-2 px-3 py-1.5',
  leading: 'flex shrink-0 items-center gap-2 border-r border-white/10 pr-2',
  legend: 'flex shrink-0 items-center gap-2',
  controls: 'flex shrink-0 items-center gap-1',
  actions: 'ml-auto flex shrink-0 items-center gap-1',
  settings: 'ml-0.5 flex shrink-0 items-center gap-1.5 border-l border-white/10 pl-1.5',
  trailing: 'ml-0.5 flex shrink-0 items-center gap-1 border-l border-white/10 pl-1.5',
} as const;

export const chartFrameClassName = 'flex min-h-0 min-w-0 flex-col overflow-hidden bg-[#0e0e12]';

export const chartToolbarSelectClasses = {
  button: 'w-full rounded-md text-[9px]',
  menu: 'rounded-xl border-t border-white/10',
} as const;

export function getChartStyleToggleSegments(showLine: boolean) {
  return {
    candles: showLine ? 'first' as const : undefined,
    line: showLine ? 'last' as const : undefined,
  };
}

export function getChartToolbarSelectRootClassName(widthClassName: string) {
  return `shrink-0 ${widthClassName}`;
}
